import {useDispatch, useSelector} from "react-redux";
import {useLocation, Routes, Route} from "react-router-dom";
import {useDialogContext} from "./context/DialogContextProvider";
import {useCallback, useEffect, useRef} from "react";
import {useMountEffect} from "./utils/Hooks";
import {temporary_actions} from "./redux/slice/TemporaryReducer";
import {account_actions} from "./redux/slice/AccountReducer";
import {cache_actions} from "./redux/slice/CacheReducer";
import {doLogin} from "./context/ApplicationContextProvider";
import {lang} from "./lang";
import {routes} from "./route/route";

const AppContent = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {alert} = useDialogContext();
    const account_reducer = useSelector((state) => state.account_reducer);

    // ref
    const check_count = useRef(0);
    const prev_require_login = useRef(account_reducer.require_login);

    useMountEffect(() => {
        // temp store 초기화
        dispatch(temporary_actions.clear());
    });

    const onRequireLogin = useCallback(
        async (current_pathname) => {
            // logout, 로그인과 관련된 store 비우기
            dispatch(account_actions.doLogout());
            dispatch(cache_actions.removeAll());

            await alert(lang.login.require_login_confirm);

            doLogin(current_pathname);
        },
        [dispatch, alert]
    );

    useEffect(() => {
        if (check_count.current > 0 && prev_require_login.current !== account_reducer.require_login) {
            onRequireLogin(location.pathname);
        }

        prev_require_login.current = account_reducer.require_login;
        check_count.current++;
    }, [account_reducer.require_login, onRequireLogin, location.pathname]);

    return (
        <div style={{width: "initial", minHeight: "66.5vh"}}>
            <Routes>
                {routes.map(({path, component}, index) => {
                    return <Route key={index} path={path} element={component} />;
                })}
            </Routes>
        </div>
    );
};

export default AppContent;
